// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import NewIcon from 'components/common/Icons/NewIcon/NewIcon';

type Props = {
  to: string,
  children: any,
  isNew?: boolean,
  onClickOutside(): void,
};

const UserMobileMenuLink = ({ to, isNew, children, onClickOutside }: Props) => {
  return (
    <Link to={to} onClick={onClickOutside} className="item-link">
      <span>
        {children}
        {isNew && <NewIcon />}
      </span>
    </Link>
  );
};

export default UserMobileMenuLink;



// WEBPACK FOOTER //
// ./src/components/base/UserMobileMenuLink/UserMobileMenuLink.js